import React from "react";
import ActionItemProps from "./ActionItemProps";
import {CircularProgress} from "@mui/material";

const ActionItem = (props: ActionItemProps) => {
  return (
    <div className="header-action-item" onClick={()=>props.onClick()} >
      <img
        src={require(`../../../../assets/images/${props.imgSrcPath}`)}
        alt={props.alt}
        width={23}
        height={23}
        role="presentation"
        aria-hidden="true"
      />
      <a className="sidebar-actions-button-text">{props.text}</a>
        {props.loading ? <CircularProgress size={"1rem"}/> : "" }
    </div>
  );
};

export default ActionItem;
